import { Component } from '@angular/core';

@Component({
    selector: 'app-results-loader',
    standalone: true,
    imports: [],
    templateUrl: './results-loader.component.html',
    styleUrl: './results-loader.component.scss'
})
export class ResultsLoaderComponent {

}
